module.exports = __webpack_public_path__ + "img/landing_gvc.14e08374.jpg";